import { getDurada, removeHtmlTags } from '@portal-internet/core';
import CodiEspectador from 'components/3cat/CodiEspectador';
import Enllac from 'components/3cat/Enllac';
import __isEmpty from 'lodash/isEmpty';
import styles from './quadrat.module.scss';

const Info = (props) => {
    const { data, route, mostraCodiEtic, tag } = props;
    const { codi_etic, titol, durada, codi_alt } = data;
    const Tag = tag || `${'h2'}`;
    const _getEntradeta = () => {
        const { entradeta_promo, entradeta } = data;
        return removeHtmlTags(entradeta_promo || entradeta);
    };

    const _showEntradeta = () => {
        const entradeta = _getEntradeta();
        return (
            <>
                {!__isEmpty(titol) && <Tag className={styles.titol}>{titol}</Tag>}
                {!__isEmpty(entradeta) && (
                    <div className={styles.entradeta} dangerouslySetInnerHTML={{ __html: entradeta }}></div>
                )}
            </>
        );
    };

    const _showCodiEspectador = (mostraCodiEtic) => {
        if (__isEmpty(codi_etic) || !mostraCodiEtic) {
            return null;
        }
        return <CodiEspectador className={styles.codiespectador} codi={codi_etic} alt={codi_alt} mida={20} />;
    };

    const _showDurada = () => durada && <span className={styles.durada}>{getDurada(durada)}</span>;
    return (
        <>
            <Enllac route={route} className={styles.textWrapper}>
                {_showEntradeta()}
                <div className={styles.extrainfo}>
                    <div>
                        {_showCodiEspectador(mostraCodiEtic)}
                        {_showDurada()}
                    </div>
                </div>
            </Enllac>
        </>
    );
};
export default Info;
